import { render, staticRenderFns } from "./RegistrationReportTableDetail.vue?vue&type=template&id=ee6a8eb4&scoped=true"
import script from "./RegistrationReportTableDetail.vue?vue&type=script&lang=js"
export * from "./RegistrationReportTableDetail.vue?vue&type=script&lang=js"
import style0 from "./RegistrationReportTableDetail.vue?vue&type=style&index=0&id=ee6a8eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6a8eb4",
  null
  
)

export default component.exports